module.exports = __webpack_public_path__ + "static/media/41.993a1515.ogg";